import { tools } from '../data/portfolio';
import { ToolLogo } from './Ornaments';
import { Reveal } from './Motion';

export const Tools = () => <section className="tools-section page-inset" data-testid="tools-section" aria-labelledby="tools-heading">
  <Reveal className="tools-intro"><span className="eyebrow chapter-label" data-testid="tools-label">04 / TOOLS</span>
    <h2 id="tools-heading" data-testid="tools-heading">MY CREATIVE TOOLKIT.</h2>
    <p data-testid="tools-description">A small but mighty set of tools that helps me move from idea to execution.</p>
  </Reveal>
  <div className="tools-grid">{tools.map((tool, i) => <Reveal className="tool-card" key={tool.id} delay={i * 0.075} data-testid={`tool-${tool.id}`}>
    <div className="tool-icon-wrap" data-testid={`tool-logo-container-${tool.id}`}><ToolLogo name={tool.id} /></div>
    <h3 data-testid={`tool-name-${tool.id}`}>{tool.title}</h3>
  </Reveal>)}</div>
</section>;